module.exports = __webpack_public_path__ + "static/media/icon-order-ani.9bd41de1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/icon-order-ani.png
// module id = 650
// module chunks = 1